import { classMap } from './colors';
import { semanticTokens } from './semanticTokens';

function aliases(group) {
  return Object.fromEntries(
    Object.entries(semanticTokens[group]).flatMap(([name, modes]) =>
      Object.entries(modes).map(([mode, value]) => [
        `${mode}-${group === 'text' && name === 'default' ? 'base' : name}`,
        value,
      ]),
    ),
  );
}

// Browser-safe literal colors for Stripe, React Select, and legacy Tailwind aliases.
// Do not import tailwind.config.js from application code: it contains build plugins.
export const legacyThemeColors = {
  colors: { ...classMap, ...aliases('color') },
  textColor: aliases('text'),
  borderColor: aliases('border'),
  backgroundColor: aliases('bg'),
};
